// frontend/src/GiftCards/common.jsx
import React, { useCallback, useEffect, useState } from 'react';
import { StatusPill } from '../ui';
import { Alert } from '../ItAssets/common';

export { Alert };
export const money = (n) => `$${Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const when = (iso) => (iso ? new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York' }) : '');
export const duration = (a, b) => { if (!a || !b) return ''; const s = Math.round((new Date(b) - new Date(a)) / 1000); return s >= 60 ? `${Math.floor(s / 60)} min ${s % 60} s` : `${s} s`; };
export const STATUS = { queued: ['Starting', 'hold'], running: ['Running', 'hold'], finished: ['Finished', 'ful'], failed: ['Failed', 'can'], interrupted: ['Interrupted', 'can'] };
export const CARD_STATUS = { pending: ['Pending', 'neu'], created: ['Account made', 'hold'], loaded: ['Loaded', 'ful'], failed: ['Failed', 'can'] };
export const Pill = ({ tone, children }) => <StatusPill tone={tone}>{children}</StatusPill>;
export const JobPill = ({ job }) => { const [label, tone] = STATUS[job.status] || [job.status, 'neu']; return <Pill tone={job.status === 'finished' && job.cards_failed > 0 ? 'hold' : tone}>{job.status === 'finished' && job.cards_failed > 0 ? `Finished, ${job.cards_failed} failed` : label}</Pill>; };

export function Progress({ done, total, failed, cancelled }) {
  const pct = total ? Math.round((100 * done) / total) : 0;
  return <div className="uh-gc-bar" title={`${done} of ${total} loaded${failed ? `, ${failed} failed` : ''}${cancelled ? `, ${cancelled} cancelled` : ''}`}><i style={{ width: `${pct}%` }} className={failed ? 'warn' : ''} /><span className="uh-num">{done}/{total}</span></div>;
}

export function useList(load, deps) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const reload = useCallback(() => load().then((d) => { setError(''); setData(d); }).catch((e) => setError(e.message)), deps); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { reload(); }, [reload]);
  return { data, error, reload, setData };
}
